angular.module('app.controllers').controller('ProjectsCtrl', function (DataTablesFactory, projectsListFilter, projectsList) {
    const vm = this;

    vm.projects = projectsList.list;
    vm.stats = projectsList.stats;
    vm.filter = projectsListFilter;

    vm.dt = DataTablesFactory.init({
        scope: vm,
    });
});
